module.exports = __webpack_public_path__ + "static/media/camera-empty.e31bd7e8.svg";